export default __webpack_public_path__ + "static/media/GMaduroPresidenteOpen.864c66bd.jpg";